// @react
import React, { ReactElement } from 'react'
// @design
import PageTitle from '@bit/atd.web.page-title'
// @components
import DocumentTitle from 'react-document-title'
// @module Components
import CommunicationContainer from 'modules/profile/components/Communication'
import PageWrapper from 'modules/profile/components/PageWrapper'

/**
 * 5.0.4 - Profile - Communication
 * UX: https://www.figma.com/file/jCo0D2EYkVbuBX1TjR1enA/ATD-MyATD-Desktop-2020?node-id=3247%3A5776
 */

const Communication = (): ReactElement => {
  return (
    <PageWrapper>
      <DocumentTitle title="Profile - Security | ATD">
        <>
          <PageTitle>Communication Preferences</PageTitle>
          <CommunicationContainer />
        </>
      </DocumentTitle>
    </PageWrapper>
  )
}

export default Communication
